import styled, {css} from 'styled-components'

export const StyledAgendaDateRoomFields = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: ${spacing * 4}px;
        width: 100%;
    `
)
